import { defineSteps, step } from 'flows/common/helpers/defineSteps'
import FirstCreation from 'flows/common/steps/FirstCreation/FirstCreation'

export const firstCreationSteps = defineSteps([
  step('firstCreation', FirstCreation)
    .allowSkip()
    .withExtra((ctx) => ({
      brandKit: ctx.brandKit,
    })),
])
